import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { DownloadTrackingOptOut } from "@/components/DownloadTrackingOptOut";

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="pt-32 pb-24">
        <div className="container mx-auto px-4 max-w-4xl">
          <Breadcrumbs items={[{ label: "Datenschutzerklärung" }]} />
          <h1 className="break-words text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-8">
            Datenschutzerklärung
          </h1>

          <div className="space-y-8 text-foreground">
            <section>
              <h2 className="text-2xl font-semibold mb-4">Verantwortlicher</h2>
              <p className="text-muted-foreground leading-relaxed">
                <strong className="text-foreground">EAP® Produktions- und Patentverwertungs-GmbH</strong><br />
                Lorettostraße 26 | 6060 Hall in Tirol<br />
                FN 483289w | UID: ATU72852709<br />
                TEL: +43 (0)677 620 565 43<br />
                E-Mail: <a href="mailto:datenschutz@eap-abutments.com" className="text-primary hover:underline">datenschutz@eap-abutments.com</a><br />
                Web: <a href="https://eap-abutments.com" className="text-primary hover:underline">eap-abutments.com</a>
              </p>
              <p className="text-muted-foreground mt-4">
                Es ist <strong>kein</strong> Datenschutzbeauftragter bestellt, da dies gesetzlich nicht notwendig ist.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Allgemeines</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Der Schutz und die Sicherheit Ihrer persönlichen Daten sind uns ein wichtiges Anliegen. 
                Diese Webseite speichert und verarbeitet Daten daher ausschließlich im Sinne der österreichischen 
                und europäischen Datenschutzgrundverordnung (DSGVO). Sie als Nutzer stimmen der Datenverarbeitung 
                im Sinne dieser Erklärung zu. Die aktuelle Fassung der DSGVO finden Sie unter{" "}
                <a href="http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE" 
                   className="break-all text-primary hover:underline" target="_blank" rel="noopener noreferrer">
                  http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE
                </a>
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Diese Datenschutzerklärung bezieht sich nur auf diese Webseite. Falls Sie über Links auf unseren Seiten 
                auf andere Seiten weitergeleitet werden, informieren Sie sich direkt auf der weitergeleiteten Webseite 
                über den jeweiligen Umgang mit Ihren Daten.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Die Nutzung dieser Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. 
                Soweit auf unseren Seiten personenbezogene Daten erhoben werden, erfolgt dies, soweit möglich, 
                stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) 
                Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Betroffenenrechte</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Nach österreichischem Datenschutzrecht sowie der europäischen DSGVO stehen Ihnen als Betroffener 
                umfangreiche Rechte zu. Ihre Rechte als betroffene Person sind:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 mb-4 ml-4">
                <li>Recht auf Auskunft über die Sie betreffenden personenbezogenen Daten</li>
                <li>Recht auf Berichtigung</li>
                <li>Recht auf Löschung</li>
                <li>Recht auf Einschränkung der Verarbeitung</li>
                <li>Recht auf Widerspruch gegen die Verarbeitung</li>
                <li>Recht auf Datenübertragbarkeit</li>
                <li>Recht auf jederzeitigen Widerruf einer Einwilligung</li>
              </ul>
              <p className="text-muted-foreground leading-relaxed">
                Sie können Ihre Rechte per E-Mail an{" "}
                <a href="mailto:datenschutz@eap-abutments.com" className="text-primary hover:underline">
                  datenschutz@eap-abutments.com
                </a>{" "}
                ausüben.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Datenlöschung</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Ihre Daten werden gelöscht, sobald der jeweilige Vertrag mit Ihnen erfüllt ist und keine gesetzliche 
                Pflicht zur Speicherung der Daten mehr besteht. Grundsätzlich werden Ihre Daten nach sieben Jahren gelöscht 
                (Aufbewahrungsfrist nach § 132 BAO).
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Gesetzliche/rechtliche Aufbewahrungspflichten oder vertragliche Verpflichtungen z.B. gegenüber Kunden 
                aus Gewährleistung oder Schadenersatz sind eine Grundlage, die personenbezogenen Daten weiterhin zu speichern 
                (Art 6 Abs 1 lit c DSGVO).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Informationen über Cookies</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Die Internetseiten verwenden teilweise sogenannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden 
                an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer 
                zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Man unterscheidet drei Kategorien von Cookies:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 mb-4 ml-4">
                <li>Unbedingt notwendige Cookies um grundlegende Funktionen der Website sicherzustellen</li>
                <li>Funktionelle Cookies um die Leistung der Webseite sicherzustellen</li>
                <li>Zielorientierte Cookies um das Benutzererlebnis zu verbessern</li>
              </ul>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Die meisten der von uns verwendeten Cookies sind so genannte „Session-Cookies". Sie werden nach Ende Ihres 
                Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies 
                nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie 
                das automatische Löschen der Cookies beim Schließen des Browsers aktivieren.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Kontaktformular</h2>
              <p className="text-muted-foreground leading-relaxed">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular 
                inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall 
                von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Admin-Panel und Tracking-Einstellungen</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Unsere Website verfügt über ein geschütztes Admin-Panel zur Verwaltung von Tracking- und Analytics-Einstellungen. 
                Der Zugang zu diesem Bereich erfolgt über eine sichere Authentifizierung.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Die im Admin-Panel gespeicherten Tracking-IDs (Google Analytics 4) werden sicher in unserer 
                Datenbank verwahrt und sind nur für authentifizierte Administratoren zugänglich. Diese Einstellungen dienen 
                ausschließlich der Optimierung unserer Website und werden nicht an Dritte weitergegeben.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Google Analytics 4</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics 4. Anbieter ist die Google Ireland Limited, 
                Gordon House, Barrow Street, Dublin 4, Irland.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Google Analytics verwendet Cookies und andere Tracking-Technologien, um die Nutzung dieser Website zu analysieren. 
                Die durch die Cookies erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an einen 
                Server von Google in den USA übertragen und dort gespeichert.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Diese Website benutzt Google Analytics mit der Erweiterung „anonymizeIP()", damit die IP-Adressen nur gekürzt 
                weiterverarbeitet werden, um eine direkte Personenbeziehbarkeit auszuschließen.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der Datenschutzerklärung 
                von Google:{" "}
                <a href="https://support.google.com/analytics/answer/6004245?hl=de" 
                   className="break-all text-primary hover:underline" target="_blank" rel="noopener noreferrer">
                  https://support.google.com/analytics/answer/6004245?hl=de
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Social Media Links</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Unsere Website enthält Links zu unseren Social-Media-Präsenzen auf LinkedIn und YouTube. 
                Diese Links sind reine externe Verlinkungen ohne Einbindung von Tracking-Technologien.
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 mb-4 ml-4">
                <li>
                  LinkedIn:{" "}
                  <a href="https://www.linkedin.com/company/eap-abutments" 
                     className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
                    https://www.linkedin.com/company/eap-abutments
                  </a>
                </li>
                <li>
                  YouTube:{" "}
                  <a href="https://www.youtube.com/@eap-abutments" 
                     className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
                    https://www.youtube.com/@eap-abutments
                  </a>
                </li>
              </ul>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Wenn Sie auf einen dieser Links klicken, verlassen Sie unsere Website und werden zur jeweiligen 
                Social-Media-Plattform weitergeleitet. Erst durch Ihren Klick und den Besuch der externen Seite 
                gelten die Datenschutzbestimmungen der jeweiligen Plattform.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Wir nutzen keine Social-Media-Plugins, Tracking-Pixel oder andere Dienste, die bereits beim 
                bloßen Besuch unserer Website Daten an LinkedIn oder YouTube übertragen würden.
              </p>
            </section>


            <section>
              <h2 className="text-2xl font-semibold mb-4">Schriftarten</h2>
              <p className="text-muted-foreground leading-relaxed">
                Wir verwenden auf unserer Webseite die Schriftart "Lato". Diese wird lokal von unserem eigenen Server geladen. 
                Es findet keine Datenübermittlung an Google oder andere Drittanbieter statt. 
                Ihr Browser lädt die benötigten Schriftdateien direkt von unserer Website herunter, 
                wodurch Ihre Privatsphäre geschützt ist und keine personenbezogenen Daten an Dritte übertragen werden.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">SSL-Verschlüsselung</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Diese Seite nutzt aus Gründen der Sicherheit und zum Schutz der Übertragung vertraulicher Inhalte, 
                wie zum Beispiel der Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-Verschlüsselung. 
                Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf 
                „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Wenn die SSL-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, 
                nicht von Dritten mitgelesen werden.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Erhebung und Speicherung personenbezogener Daten</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Beim Aufrufen dieser Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser 
                automatisch Informationen an den Server unserer Website gesendet. Diese Informationen werden temporär 
                in einem sog. Logfile gespeichert. Folgende Informationen werden dabei ohne Ihr Zutun erfasst und bis 
                zur automatisierten Löschung gespeichert:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 mb-4 ml-4">
                <li>IP-Adresse des anfragenden Rechners</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Name und URL der abgerufenen Datei</li>
                <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
                <li>Verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie der Name Ihres Access-Providers</li>
              </ul>
              <p className="text-muted-foreground leading-relaxed">
                Die erhobenen Daten dienen der Gewährleistung eines reibungslosen Verbindungsaufbaus der Website, 
                der Gewährleistung einer komfortablen Nutzung unserer Website, der Auswertung der Systemsicherheit 
                und -stabilität sowie zu weiteren administrativen Zwecken.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Datensicherheit</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Der Anbieter setzt technische und organisatorische Sicherheitsmaßnahmen ein, um die von den Nutzerinnen 
                bzw. Nutzern durch den Anbieter gespeicherten Daten gegen zufällige oder vorsätzliche Manipulation, Verlust, 
                Zerstörung oder gegen den Zugriff unberechtigter Personen zu schützen.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Alle Daten werden auf sicheren Servern gespeichert, mit denen Verträge zur Auftragsverarbeitung nach DSGVO 
                mit entsprechender Prüfung abgeschlossen wurden.
              </p>
            </section>

            <section>

              <h2 className="text-2xl font-semibold mb-4">Datenverarbeitung im B2B-Bereich (Geschäftskunden)</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                EAP Abutments® richtet sich ausschließlich an zahnärztliche und zahntechnische Fachkreise
                (Zahnärztinnen und Zahnärzte, Kliniken, Dentallabore, Fachhandel). Auch im
                Geschäftskundenverkehr (B2B) gilt die DSGVO uneingeschränkt, da wir personenbezogene Daten
                von Ansprechpersonen in diesen Unternehmen verarbeiten.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-2">
                <strong className="text-foreground">Verarbeitete Datenkategorien:</strong>
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 mb-4 ml-4">
                <li>Stammdaten der Ansprechperson: Vor- und Nachname, Funktion/Berufsbezeichnung</li>
                <li>Kontaktdaten: geschäftliche E-Mail-Adresse, Telefonnummer, Praxis-/Laboradresse</li>
                <li>Unternehmensdaten: Firmenname, UID/USt-IdNr., Registrierungs- bzw. Berufsnachweis</li>
                <li>Nachweis der Fachkreiszugehörigkeit (Verifizierung des Zugangs zum B2B-Bereich)</li>
                <li>Vertrags- und Abwicklungsdaten: Bestellungen, Lieferungen, Rechnungen, Zahlungsstatus</li>
                <li>Kommunikationsdaten: Anfragen, Terminvereinbarungen, Beratungsprotokolle</li>
              </ul>
              <p className="text-muted-foreground leading-relaxed mb-2">
                <strong className="text-foreground">Rechtsgrundlagen:</strong>
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 mb-4 ml-4">
                <li>Art. 6 Abs. 1 lit. b DSGVO – Vertragserfüllung bzw. Vertragsanbahnung (Bestellungen, Beratung, Support)</li>
                <li>Art. 6 Abs. 1 lit. c DSGVO – rechtliche Verpflichtungen, insbesondere Aufbewahrungspflichten nach § 132 BAO / UGB sowie Rückverfolgbarkeits- und Vigilanzpflichten für Medizinprodukte nach MDR (EU) 2017/745</li>
                <li>Art. 6 Abs. 1 lit. f DSGVO – berechtigtes Interesse an Verifizierung der Fachkreiszugehörigkeit, Missbrauchsvermeidung und IT-Sicherheit</li>
                <li>Art. 6 Abs. 1 lit. a DSGVO – Einwilligung, soweit erforderlich (z. B. Newsletter, nicht notwendige Cookies)</li>
              </ul>
              <p className="text-muted-foreground leading-relaxed mb-4">
                <strong className="text-foreground">Keine Patientendaten:</strong> Wir erheben und verarbeiten
                bewusst keine Gesundheitsdaten von Patientinnen und Patienten (Art. 9 DSGVO). Bitte übermitteln
                Sie uns bei Anfragen, Reklamationen oder Fallbesprechungen ausschließlich anonymisierte oder
                pseudonymisierte Unterlagen (z. B. Röntgenbilder ohne Namen, Geburtsdatum oder Patienten-ID).
                Sollten uns dennoch Patientendaten zugehen, werden diese ausschließlich zur Erfüllung
                regulatorischer Pflichten (Vigilanz nach MDR) verwendet und ansonsten unverzüglich gelöscht.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                <strong className="text-foreground">Speicherdauer:</strong> Vertrags-, Rechnungs- und
                Buchhaltungsdaten werden 7 Jahre aufbewahrt (§ 132 BAO). Daten zur Rückverfolgbarkeit von
                Medizinprodukten werden gemäß MDR mindestens 10 Jahre nach Inverkehrbringen der letzten
                Charge aufbewahrt. Reine Kontakt- und Kommunikationsdaten ohne gesetzliche Aufbewahrungspflicht
                löschen wir, sobald der Zweck entfällt, spätestens 3 Jahre nach dem letzten Kontakt.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                <strong className="text-foreground">Werbliche Ansprache:</strong> Fachinformationen an
                bestehende Geschäftskunden versenden wir auf Grundlage von § 174 Abs. 4 TKG 2021 bzw.
                Art. 6 Abs. 1 lit. f DSGVO. Ein Widerspruch ist jederzeit über den Abmeldelink oder per
                E-Mail an datenschutz@eap-abutments.com möglich – ohne Nachteile für die Geschäftsbeziehung.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Terminbuchung und Videoberatung</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Über unser Buchungsformular können Sie einen kostenlosen Beratungstermin (Videocall) vereinbaren.
                Dabei verarbeiten wir Name, E-Mail-Adresse, Telefonnummer (Pflichtfeld für Rückfragen und
                kurzfristige Terminänderungen), Praxis-/Laborname sowie Ihren Terminwunsch und optionale
                Anmerkungen.
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 mb-4 ml-4">
                <li>Zweck: Terminvereinbarung, Terminbestätigung, Durchführung der Fachberatung</li>
                <li>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung auf Ihre Anfrage)</li>
                <li>Sie erhalten eine Bestätigungs-E-Mail inkl. Kalenderdatei (.ics) und Zugangslink zum Videocall</li>
                <li>Der Videocall findet über Microsoft Teams statt (Microsoft Ireland Operations Ltd.); es gelten zusätzlich die Datenschutzhinweise von Microsoft</li>
                <li>Videocalls werden nicht aufgezeichnet</li>
                <li>Der E-Mail-Versand erfolgt über Resend (Auftragsverarbeiter)</li>
                <li>Terminanfragen werden nach 12 Monaten gelöscht, sofern keine Geschäftsbeziehung entsteht</li>
              </ul>
              <p className="text-muted-foreground leading-relaxed">
                Terminbestätigungen werden intern an die zuständigen Ansprechpersonen unseres Unternehmens
                weitergeleitet, um die Beratung vorzubereiten und durchzuführen.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Download-Statistik und Reichweitenmessung</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Wenn Sie auf unserer Website Dateien herunterladen (z. B. Produktbroschüre,
                Studien-Zusammenfassung, Leitfaden Technikerzettel, AI-&amp;-Press-One-Pager), erfolgt der
                Abruf <strong>nur dann</strong> über eine eigene Zählfunktion auf unserem Server, die den
                Download protokolliert und Sie anschließend automatisch zur Datei weiterleitet, wenn Sie im
                Cookie-Banner der Kategorie „Analyse“ zugestimmt haben. Ohne Ihre Einwilligung wird die Datei
                direkt ausgeliefert – ohne Protokollierung und ohne pseudonyme Kennung.
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 mb-4 ml-4">
                <li>
                  Gespeicherte Angaben: Dateikennung, Zeitpunkt, gewählte Sprache, Gerätekategorie
                  (Desktop/Tablet/Mobil), ggf. Länderkennung sowie die verweisende Domain
                </li>
                <li>
                  <strong>Keine Speicherung Ihrer IP-Adresse</strong> und keine Speicherung von Namen oder
                  E-Mail-Adressen im Rahmen der Download-Zählung
                </li>
                <li>
                  Zusätzlich wird eine <strong>pseudonyme Kennung</strong> (zufällige Zeichenfolge) verwendet, die
                  ausschließlich lokal in Ihrem Browser (localStorage, Schlüssel <code>eap-visitor-id</code>)
                  gespeichert wird. Sie enthält keine personenbezogenen Daten und ermöglicht keine
                  Identifizierung Ihrer Person.
                </li>
                <li>
                  Zweck: statistische Auswertung, welche Fachinformationen nachgefragt werden und ob
                  Downloads zu Kontakt- oder Terminanfragen führen (Erfolgsmessung unserer
                  Fachinformationen)
                </li>
                <li>
                  Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) sowie § 25 Abs. 1 TDDDG für die
                  Speicherung der Kennung im lokalen Speicher; die Verarbeitung erfolgt datenminimierend und
                  ohne Profilbildung
                </li>
                <li>
                  Wird nach einem Download über unser Kontakt- oder Buchungsformular eine Anfrage
                  gesendet, wird diese pseudonyme Kennung mitgespeichert, damit wir rein statistisch
                  auswerten können, wie viele Anfragen aus Downloads entstehen. Eine Zusammenführung zu
                  einem Nutzerprofil oder eine werbliche Ansprache auf dieser Basis findet nicht statt.
                </li>
                <li>Speicherdauer der Download-Statistik: 24 Monate; danach Löschung</li>
                <li>
                  Widerruf/Deaktivierung: Sie können Ihre Einwilligung jederzeit über den Link
                  „Cookie-Einstellungen“ im Seitenfuß widerrufen. Beim Widerruf wird die pseudonyme Kennung
                  sofort aus Ihrem Browser gelöscht und es erfolgt keine weitere Download-Protokollierung.
                  Alternativ können Sie den lokalen Speicher Ihres Browsers löschen. Die Downloads selbst
                  funktionieren unabhängig davon.
                </li>
              </ul>
              <p className="text-muted-foreground leading-relaxed mb-6">
                Ein Widerspruch gegen diese Verarbeitung ist jederzeit unter{" "}
                <a href="mailto:datenschutz@eap-abutments.com" className="text-primary hover:underline">
                  datenschutz@eap-abutments.com
                </a>{" "}
                möglich.
              </p>
              <DownloadTrackingOptOut />
            </section>



            <section>
              <h2 className="text-2xl font-semibold mb-4">
                Drittanbieter, eingesetzte Tools und Auftragsverarbeiter
              </h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Nachfolgend finden Sie eine konkrete Übersicht aller Dienste, die beim Betrieb dieser Website
                zum Einsatz kommen, samt Zweck, Rechtsgrundlage, Serverstandort und Grundlage einer allfälligen
                Drittlandübermittlung. Mit allen Auftragsverarbeitern bestehen Verträge nach Art. 28 DSGVO.
              </p>
              <div className="max-w-full overflow-x-auto mb-4">
                <table className="w-full min-w-[640px] text-sm border-collapse">
                  <thead>
                    <tr className="text-left border-b border-border">
                      <th className="py-2 pr-4 font-semibold">Dienst / Anbieter</th>
                      <th className="py-2 pr-4 font-semibold">Zweck &amp; verarbeitete Daten</th>
                      <th className="py-2 pr-4 font-semibold">Standort / Übermittlung</th>
                      <th className="py-2 font-semibold">Rechtsgrundlage</th>
                    </tr>
                  </thead>
                  <tbody className="text-muted-foreground">
                    <tr className="border-b border-border/60 align-top">
                      <td className="py-2 pr-4 font-medium text-foreground">
                        Lovable Cloud (Website-Hosting, CDN, Datenbank, Authentifizierung, Server-Funktionen)
                      </td>
                      <td className="py-2 pr-4">
                        Auslieferung der Website, Server-Logfiles (gekürzte IP-Adresse, Zeitpunkt, abgerufene
                        Ressource, User-Agent), Speicherung von Kontakt- und Terminanfragen, Blogbeiträgen und
                        Download-Statistik
                      </td>
                      <td className="py-2 pr-4">Rechenzentrum EU (Frankfurt am Main, DE)</td>
                      <td className="py-2">Art. 6 Abs. 1 lit. b und f DSGVO</td>
                    </tr>
                    <tr className="border-b border-border/60 align-top">
                      <td className="py-2 pr-4 font-medium text-foreground">
                        Hetzner Online GmbH (Root-Server für den B2B-Fachkreis-Shop)
                      </td>
                      <td className="py-2 pr-4">
                        Betrieb von Shop und Verwaltung, Bestell- und Kundendaten verifizierter Fachkreise,
                        Server-Logs
                      </td>
                      <td className="py-2 pr-4">Deutschland (EU)</td>
                      <td className="py-2">Art. 6 Abs. 1 lit. b DSGVO</td>
                    </tr>
                    <tr className="border-b border-border/60 align-top">
                      <td className="py-2 pr-4 font-medium text-foreground">
                        Microsoft Ireland Operations Ltd. (Microsoft Teams, Microsoft 365)
                      </td>
                      <td className="py-2 pr-4">
                        Videoberatung (Name, E-Mail, Termindaten, Verbindungsdaten), E-Mail-Korrespondenz und
                        Kalender
                      </td>
                      <td className="py-2 pr-4">
                        EU, Support-Zugriffe aus den USA möglich – EU-US Data Privacy Framework und
                        EU-Standarddatenschutzklauseln
                      </td>
                      <td className="py-2">Art. 6 Abs. 1 lit. b und f DSGVO</td>
                    </tr>
                    <tr className="border-b border-border/60 align-top">
                      <td className="py-2 pr-4 font-medium text-foreground">
                        Resend (Resend Inc.) – transaktionaler E-Mail-Versand
                      </td>
                      <td className="py-2 pr-4">
                        Versand von Termin- und Kontaktbestätigungen inkl. Kalenderdatei (Name, E-Mail,
                        Telefonnummer, Nachricht)
                      </td>
                      <td className="py-2 pr-4">
                        USA – EU-Standarddatenschutzklauseln, Verschlüsselung in Transit
                      </td>
                      <td className="py-2">Art. 6 Abs. 1 lit. b DSGVO</td>
                    </tr>
                    <tr className="border-b border-border/60 align-top">
                      <td className="py-2 pr-4 font-medium text-foreground">
                        Stripe Payments Europe Ltd. – Zahlungsabwicklung im B2B-Shop
                      </td>
                      <td className="py-2 pr-4">
                        Zahlungsdaten, Rechnungs- und Transaktionsdaten (PCI-DSS Level 1); Kartendaten werden
                        von uns nicht gespeichert
                      </td>
                      <td className="py-2 pr-4">Irland (EU), Konzernübermittlung USA über DPF/SCC</td>
                      <td className="py-2">Art. 6 Abs. 1 lit. b und c DSGVO</td>
                    </tr>
                    <tr className="border-b border-border/60 align-top">
                      <td className="py-2 pr-4 font-medium text-foreground">
                        Google Ireland Ltd. – Google Analytics 4
                      </td>
                      <td className="py-2 pr-4">
                        Reichweitenmessung mit IP-Kürzung, Geräte- und Nutzungsdaten, Cookie-Kennungen; wird
                        erst nach Ihrer Einwilligung geladen
                      </td>
                      <td className="py-2 pr-4">EU/USA – EU-US Data Privacy Framework, SCC</td>
                      <td className="py-2">Art. 6 Abs. 1 lit. a DSGVO, § 25 Abs. 1 TDDDG</td>
                    </tr>
                    <tr className="border-b border-border/60 align-top">
                      <td className="py-2 pr-4 font-medium text-foreground">
                        Google Ireland Ltd. – Google Search Console
                      </td>
                      <td className="py-2 pr-4">
                        Aggregierte, nicht personenbezogene Auswertung der Sichtbarkeit unserer Seiten in der
                        Google-Suche (Suchanfragen, Klicks, Indexierungsstatus)
                      </td>
                      <td className="py-2 pr-4">EU/USA – DPF, SCC</td>
                      <td className="py-2">Art. 6 Abs. 1 lit. f DSGVO</td>
                    </tr>
                    <tr className="border-b border-border/60 align-top">
                      <td className="py-2 pr-4 font-medium text-foreground">
                        Meta Platforms Ireland Ltd. – Facebook Pixel
                      </td>
                      <td className="py-2 pr-4">
                        Messung von Werbeerfolgen, Cookie-/Geräte-Kennungen; wird ausschließlich nach
                        Einwilligung in die Kategorie „Marketing“ geladen
                      </td>
                      <td className="py-2 pr-4">Irland (EU)/USA – DPF, SCC</td>
                      <td className="py-2">Art. 6 Abs. 1 lit. a DSGVO, § 25 Abs. 1 TDDDG</td>
                    </tr>
                    <tr className="border-b border-border/60 align-top">
                      <td className="py-2 pr-4 font-medium text-foreground">
                        AutoSEO (getautoseo.com) – Redaktionssystem für Blogbeiträge
                      </td>
                      <td className="py-2 pr-4">
                        Übermittlung fertiger Fachartikel an unsere Website über eine gesicherte Schnittstelle;
                        <strong> keine</strong> Verarbeitung von Besucherdaten
                      </td>
                      <td className="py-2 pr-4">EU/USA – SCC</td>
                      <td className="py-2">Art. 6 Abs. 1 lit. f DSGVO</td>
                    </tr>
                    <tr className="border-b border-border/60 align-top">
                      <td className="py-2 pr-4 font-medium text-foreground">
                        KI-Übersetzungsdienst (serverseitig, über unseren Cloud-Anbieter)
                      </td>
                      <td className="py-2 pr-4">
                        Automatische Übersetzung von Blog- und Fachtexten in unsere sechs Sprachversionen;
                        verarbeitet werden ausschließlich redaktionelle Inhalte, keine Besucher- oder Kundendaten
                      </td>
                      <td className="py-2 pr-4">EU/USA – SCC</td>
                      <td className="py-2">Art. 6 Abs. 1 lit. f DSGVO</td>
                    </tr>
                    <tr className="align-top">
                      <td className="py-2 pr-4 font-medium text-foreground">
                        Steuerberatung, Buchhaltung, Logistik- und Versanddienstleister
                      </td>
                      <td className="py-2 pr-4">
                        Abwicklung von Bestellungen, Rechnungslegung und gesetzlichen Aufbewahrungspflichten
                      </td>
                      <td className="py-2 pr-4">Österreich/EU</td>
                      <td className="py-2">Art. 6 Abs. 1 lit. b und c DSGVO</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="text-muted-foreground leading-relaxed">
                Schriftarten werden lokal von unserem Server ausgeliefert – es erfolgt <strong>kein</strong>
                {" "}Verbindungsaufbau zu Google Fonts. Erfolgt im Einzelfall eine Übermittlung in ein Drittland,
                geschieht dies ausschließlich auf Basis eines Angemessenheitsbeschlusses (z. B. EU-US Data
                Privacy Framework) oder von EU-Standarddatenschutzklauseln samt zusätzlicher Schutzmaßnahmen.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Speicherdauern im Überblick</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Wir speichern personenbezogene Daten nur so lange, wie es für den jeweiligen Zweck erforderlich
                ist oder gesetzliche Aufbewahrungsfristen bestehen:
              </p>
              <div className="overflow-x-auto mb-4">
                <table className="w-full text-sm border-collapse">
                  <thead>
                    <tr className="text-left border-b border-border">
                      <th className="py-2 pr-4 font-semibold">Datenkategorie</th>
                      <th className="py-2 font-semibold">Speicherdauer</th>
                    </tr>
                  </thead>
                  <tbody className="text-muted-foreground">
                    <tr className="border-b border-border/60">
                      <td className="py-2 pr-4">Server-Logfiles (gekürzte IP, Zugriffszeit)</td>
                      <td className="py-2">7 Tage, danach automatische Löschung</td>
                    </tr>
                    <tr className="border-b border-border/60">
                      <td className="py-2 pr-4">Kontaktanfragen und zugehörige E-Mail-Korrespondenz</td>
                      <td className="py-2">
                        6 Monate nach abgeschlossener Bearbeitung; bei Vertragsanbahnung 3 Jahre (Verjährung)
                      </td>
                    </tr>
                    <tr className="border-b border-border/60">
                      <td className="py-2 pr-4">Termin- und Videoberatungsdaten (Name, E-Mail, Telefon, Termin)</td>
                      <td className="py-2">12 Monate nach dem Termin</td>
                    </tr>
                    <tr className="border-b border-border/60">
                      <td className="py-2 pr-4">Download-Statistik und pseudonyme Besucherkennung</td>
                      <td className="py-2">24 Monate; Widerruf oder Opt-out wirkt sofort</td>
                    </tr>
                    <tr className="border-b border-border/60">
                      <td className="py-2 pr-4">Google-Analytics-Daten</td>
                      <td className="py-2">14 Monate (Standard-Aufbewahrung von GA4)</td>
                    </tr>
                    <tr className="border-b border-border/60">
                      <td className="py-2 pr-4">Cookie-Einwilligung (Nachweispflicht)</td>
                      <td className="py-2">
                        Bis zum Widerruf, längstens 12 Monate; danach wird erneut abgefragt
                      </td>
                    </tr>
                    <tr className="border-b border-border/60">
                      <td className="py-2 pr-4">B2B-Kunden-, Bestell- und Zahlungsdaten</td>
                      <td className="py-2">
                        7 Jahre gemäß § 132 BAO / § 212 UGB, Gewährleistungsunterlagen bis zu 10 Jahre
                      </td>
                    </tr>
                    <tr>
                      <td className="py-2 pr-4">Nachweise der Fachkreis-Verifizierung (B2B-Shop)</td>
                      <td className="py-2">Für die Dauer der Geschäftsbeziehung, danach 3 Jahre</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="text-muted-foreground leading-relaxed">
                Nach Ablauf der jeweiligen Frist werden die Daten gelöscht oder unumkehrbar anonymisiert.
                Bestehen gesetzliche Aufbewahrungspflichten, wird die Verarbeitung bis zum Fristende auf die
                Aufbewahrung beschränkt (Art. 18 DSGVO).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Kontakt für DSGVO-Anfragen</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Für Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerspruch oder den
                Widerruf einer Einwilligung erreichen Sie uns direkt – bitte geben Sie an, welches Recht Sie
                ausüben möchten:
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                <strong className="text-foreground">EAP® Produktions- und Patentverwertungs-GmbH</strong>
                <br />
                Datenschutzanfragen, Lorettostraße 26, 6060 Hall in Tirol, Österreich
                <br />
                E-Mail:{" "}
                <a href="mailto:datenschutz@eap-abutments.com" className="text-primary hover:underline">
                  datenschutz@eap-abutments.com
                </a>
                <br />
                Telefon: +43 (0)677 620 565 43
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                <li>Bearbeitungsfrist: innerhalb eines Monats ab Eingang (Art. 12 Abs. 3 DSGVO)</li>
                <li>
                  Die Bearbeitung ist für Sie kostenlos; zur Identitätsprüfung können wir Rückfragen stellen
                </li>
                <li>
                  Es findet keine automatisierte Entscheidungsfindung und kein Profiling nach Art. 22 DSGVO
                  statt
                </li>
                <li>Ein Datenschutzbeauftragter ist gesetzlich nicht erforderlich und nicht bestellt</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Ihre Rechte als betroffene Person</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Ihnen stehen die Rechte auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17),
                Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie Widerspruch
                (Art. 21 DSGVO) zu. Erteilte Einwilligungen können Sie jederzeit mit Wirkung für die Zukunft
                widerrufen.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Zur Ausübung Ihrer Rechte genügt eine Nachricht an{" "}
                <a href="mailto:datenschutz@eap-abutments.com" className="text-primary hover:underline">
                  datenschutz@eap-abutments.com
                </a>
                . Wir beantworten Anfragen innerhalb eines Monats. Eine automatisierte Entscheidungsfindung
                oder ein Profiling findet nicht statt.
              </p>
            </section>


            <section>
              <h2 className="text-2xl font-semibold mb-4">Beschwerde bei der Aufsichtsbehörde</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Sie haben jederzeit das Recht, Beschwerde bei der Datenschutzbehörde einzubringen:
              </p>
              <p className="text-muted-foreground leading-relaxed">
                <strong className="text-foreground">Österreichische Datenschutzbehörde</strong><br />
                Wickenburggasse 8<br />
                1080 Wien<br />
                Telefon: +43 1 521 52-25 69<br />
                E-Mail: <a href="mailto:dsb@dsb.gv.at" className="text-primary hover:underline">dsb@dsb.gv.at</a>
              </p>
            </section>

            <section className="pt-4 border-t border-border">
              <p className="text-sm text-muted-foreground italic">
                Stand: August 2026 (Version 3.0) – ersetzt die Fassung Mai 2024 (archiviert)
              </p>
              <p className="text-sm text-muted-foreground mt-4">
                Bei Fragen wenden Sie sich bitte an folgende E-Mail-Adresse:{" "}
                <a href="mailto:datenschutz@eap-abutments.com" className="text-primary hover:underline">
                  datenschutz@eap-abutments.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Datenschutz;
